<template>
  <div>
    <div class="skeleton van-skeleton van-skeleton--animate" v-if="loading">
      <div class="van-skeleton__content">
        <!-- <h3 class="van-skeleton__title"></h3> -->
        <div class="van-skeleton__row height1"></div>
        <div class="van-skeleton__row height1"></div>
        <div class="van-skeleton__row height2"></div>
        <div class="van-skeleton__row height3"></div>
        <div class="van-skeleton__row height3"></div>
        <div class="van-skeleton__row height3"></div>
        
      </div>
    </div>
    <slot v-if="!loading"/>
  </div>
</template>
<script>

export default {
  name: '',
  components:{

  },
  props:{
    loading:{
        type: Boolean,
        default: false
      }
  },
  data () {
    return {
      title: '',
    }
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>
.height1{
  height: 3.4667rem
}
.height2{
  height: 2.4rem
}
.height3{
  height: 1.3333rem
}
</style>